import { OrderedMap, fromJS } from 'immutable';

import mappers from 'mappers';
import { EMPTY_MAP } from 'app/app.constants';
import { WELLS_ACTIONS as ACTIONS } from 'features/wells/wells.constants';
import { FIELDS_ACTIONS } from 'features/fields/fields.constants';

const initialState = EMPTY_MAP;

const fieldReducer = (state = initialState, action) => {
  const { type, error, payload } = action;

  switch (type) {
    case ACTIONS.RECEIVE_FIELDS: {
      if (error) return state;

      return OrderedMap(
        payload.map((field) => [
          field.fieldId.toString(),
          mappers.Field.from(field),
        ]),
      );
    }

    case FIELDS_ACTIONS.GET_FIELDS_WITH_ORGANIZATIONS: {
      if (error) return state;

      const immutablePayload = fromJS(payload);

      return state.setIn([payload.fieldId.toString()], immutablePayload);
    }

    default:
      return state;
  }
};

export default fieldReducer;
